import React from 'react';

const Top = () => (
  <div>
    <h2>Top Page</h2>
    <p>Hi,</p>
    <p>If you are seeing this message, your authentication app is properly running. Please keep on checking by clicking the link buttons inside the header, which were generated from the <em>Link</em> element of React Router.</p>
  </div>
)

export default Top;